var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.443 23.535l-9.95-9.595c-.795-.767-.818-2.033-.051-2.828l.05-.052 9.951-9.595c.848-.818 2.19-.818 3.038 0 .809.78.832 2.068.052 2.877l-.052.053L6.076 12.5l8.405 8.105c.809.78.832 2.069.052 2.878l-.052.052c-.848.818-2.19.818-3.038 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowBlack);
export default __webpack_public_path__ + "static/media/back-arrow-black.900d4b90b35d716816e639ad90eb2893.svg";
export { ForwardRef as ReactComponent };